import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

import translations from './translations'

const languageDetector = new LanguageDetector()
languageDetector.addDetector({
  name: 'tallinkQueryStringDetector',
  lookup() {
    if (typeof window === 'undefined') return undefined
    return convertSearchStringToLocale(window.location.search)
  }
})

i18n
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    detection: {
      order: ['tallinkQueryStringDetector']
    },
    supportedLngs: getSupportedLocales(translations),
    resources: translations,
    fallbackLng: 'fi',
    keySeparator: false,
    interpolation: {
      escapeValue: false
    }
  })

export function convertSearchStringToLocale(search) {
  const searchParams = new URLSearchParams(search)
  const language = searchParams.get('locale')
  const country = searchParams.get('country')
  if (!language) return undefined
  if (!country) return language
  if (language.length === 5) return `${language.substring(0, 2)}-${country}`
  return `${language}-${country}`
}

export function getSupportedLocales(translations) {
  const supportedCountries = ['EE', 'FI', 'LV', 'XZ']
  const supportedLanguages = Object.keys(translations)

  return supportedLanguages.flatMap(language => {
    const languageAndCountryPairs = supportedCountries.flatMap(country => [`${language}-${country}`])
    return [language, ...languageAndCountryPairs]
  })
}
